import type { ReactElement } from 'react';
import { connect } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import type { I18nLocale } from '@ardoq/i18n';
import { ComponentMessage, ReferenceMessage } from './ContentMessage';
import { deletionEntities$ } from './deletionEntities$';
import {
  type DeletionEntities,
  getComponentDisplayNames,
  getReferenceDisplayNames,
} from './deletionEntityNames';

type ComponentMessageByIdsProps = {
  entities: DeletionEntities;
  componentIds: ArdoqId[];
  componentNames: string[] | undefined;
  numOfComponents: number;
  numOfReferences: number;
  hasSubtreeInfo: boolean;
  i18nLocale: I18nLocale;
};

const ComponentMessageByIds = ({
  entities,
  componentIds,
  componentNames,
  ...props
}: ComponentMessageByIdsProps): ReactElement => (
  <ComponentMessage
    componentNames={
      componentNames ?? getComponentDisplayNames(entities, componentIds)
    }
    {...props}
  />
);

type ReferenceMessageByIdsProps = {
  entities: DeletionEntities;
  referenceIds: ArdoqId[];
  i18nLocale: I18nLocale;
};

const ReferenceMessageByIds = ({
  entities,
  referenceIds,
  i18nLocale,
}: ReferenceMessageByIdsProps): ReactElement => (
  <ReferenceMessage
    referenceNames={getReferenceDisplayNames(entities, referenceIds)}
    i18nLocale={i18nLocale}
  />
);

export const ConnectedComponentMessage = connect(
  ComponentMessageByIds,
  deletionEntities$
);

export const ConnectedReferenceMessage = connect(
  ReferenceMessageByIds,
  deletionEntities$
);
